module.exports = __webpack_public_path__ + "media/empty-states/sponsors-2x-4a1717f8.png";